module.exports = __webpack_public_path__ + "media/images/check-image-mobile-5021cc9a.png";